import { SERVICE_SUPPORTS, STORE_STATUS } from "./store";
const Window = window as any;

export const MOBILE_BREAKPOINT = 768;
export const TOKEN_KEY = "merchant_token";
export const REFRESH_TOKEN_KEY = "merchant_refresh_token";
// export const BASE_URL = process.env.REACT_APP_BASE_URL as string;
export const BASE_URL = Window["runConfig"]["apiUrl"];

// export const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string;
export const API_KEY = Window["runConfig"]["googleMapsApiKey"];

// export const CHAT_APP_ID = process.env.REACT_APP_TENCENTIM_CHATAPPID as string;

export const REACT_APP_DEEPLINK = Window["runConfig"]["deeplink"];
export const CURRENT_STORE = "current_store";
export const MERCHANT = "merchant";
export const ALL = "all";
// export const CHAT_APP_ID = process.env.REACT_APP_TENCENTIM_CHATAPPID as string;
export const CHAT_APP_ID = Window["runConfig"]["tencentImAppId"];

export const IMAGE_TYPE_ALLOW = {
  SVG: "image/svg+xml",
  JPG: "image/jpg",
  JPEG: "image/jpeg",
  PNG: "image/png",
  MP4: "video/mp4",
};

export const COMPANY_NAME_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9.\s]*$/;
export const EMAIL_PATTERN = /^[a-zA-Z0-9._+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; //  various domains allowed (gmail.com, yahoo.com ...)
export const PHONE_NUMBER_PATTERN = /^\.*[6|8|9]\d{7}$/gm;
export const PHONE_NUMBER_VIETNAM = /([3|5|7|8|9])+([0-9]{8})\b/g;
export const LETTER_REGEX = /[a-zA-ZÀ-Ỹà-ỹ!@#$%^&*()\[\]{}\-+=_`~ |;:'",.<>/?\\]/g;
export const LETTER_REGEX_ALLOW_DECIMAL = /[a-zA-ZÀ-Ỹà-ỹ!@#$%^&*()\[\]{}\-+=_`~ |;:'",<>/?\\]/g;

export function getCurrentPattern(region: string | undefined) {
  if (!region) return PHONE_NUMBER_PATTERN;
  switch (region) {
    case "+84":
      return PHONE_NUMBER_VIETNAM;
    default:
      return PHONE_NUMBER_PATTERN;
  }
}
export enum MessageType {
  Notifications = "C2C",
}

export const StoreExample = {
  id: "1",
  name: "Store Example",
  description: "This is a description",
  logo: "https://example.com/logo.png",
  banners: ["https://example.com/banner1.png", "https://example.com/banner2.png"],
  is_restaurant: true,
  open_at: "08:00",
  close_at: "22:00",
  is_open_on_weekend: true,
  weekend_open_at: "09:00",
  weekend_close_at: "23:00",
  status: STORE_STATUS.LIVE,
  service_supports: [SERVICE_SUPPORTS.PICKUP],
  preOrderServices: [],
  create_time: "2023-11-06T00:00:00Z",
  update_time: "2023-11-06T00:00:00Z",
  merchant_id: 123,
  pickupMinOrder: 10,
  deliveryMinOrder: 10,
  outletContactPerson: "Jane Doe",
  openingHour: {
    isOpen24Hour: true,
    openingHoursMon: "08:00-18:00",
    openingHoursTue: "08:00-18:00",
    openingHoursWed: "08:00-18:00",
    openingHoursThu: "08:00-18:00",
    openingHoursFri: "08:00-18:00",
    openingHoursSat: "08:00-18:00",
    openingHoursSun: "08:00-18:00",
    closingHoursMon: "08:00-18:00",
    closingHoursTue: "08:00-18:00",
    closingHoursWed: "08:00-18:00",
    closingHoursThu: "08:00-18:00",
    closingHoursFri: "08:00-18:00",
    closingHoursSat: "08:00-18:00",
    closingHoursSun: "08:00-18:00",
    breakingStartHourMon: "08:00-18:00",
    breakingEndHourMon: "08:00-18:00",
    breakingStartHourTue: "08:00-18:00",
    breakingEndHourTue: "08:00-18:00",
    breakingStartHourWed: "08:00-18:00",
    breakingEndHourWed: "08:00-18:00",
    breakingStartHourThu: "08:00-18:00",
    breakingEndHourThu: "08:00-18:00",
    breakingStartHourFri: "08:00-18:00",
    breakingEndHourFri: "08:00-18:00",
    breakingStartHourSat: "08:00-18:00",
    breakingEndHourSat: "08:00-18:00",
    breakingStartHourSun: "08:00-18:00",
    breakingEndHourSun: "08:00-18:00",
  },
  halalCertified: true,
  muslimOwned: false,
  triFoodPOSes: [
    {
      id: 1,
      POSId: "POS1",
    },
    {
      id: 2,
      POSId: "POS2",
    },
  ],
  categoriesLevel1: [],
  categoriesLevel2: [],
  categoriesLevel3: [],

  merchantStoreApproval: [],
  isSpecialEvent: false,
  autoCloseOrderThreshold: 0,
  autoOpenOrderThreshold: 0,
  isAutoThresholdEnabled: false,
  isTerminalEnabled: false,
  type: "FOOD_DELIVERY",
};

export const StoreItemExample = {
  id: "1",
  name: "Store Example",
  description: "This is a description",
  logo: "https://example.com/logo.png",
  banners: ["https://example.com/banner1.png", "https://example.com/banner2.png"],
  is_restaurant: true,
  open_at: "08:00",
  close_at: "22:00",
  is_open_on_weekend: true,
  weekend_open_at: "09:00",
  weekend_close_at: "23:00",
  status: STORE_STATUS.LIVE,
  service_supports: [SERVICE_SUPPORTS.PICKUP],
  preOrderServices: [],
  create_time: "2023-11-06T00:00:00Z",
  update_time: "2023-11-06T00:00:00Z",
  merchant_id: 123,
  deliveryMinOrder: 10,
  pickupMinOrder: 10,
  outletContactPerson: "Jane Doe",

  openingHour: {
    isOpen24Hour: true,
    openingHoursMon: "08:00-18:00",
    openingHoursTue: "08:00-18:00",
    openingHoursWed: "08:00-18:00",
    openingHoursThu: "08:00-18:00",
    openingHoursFri: "08:00-18:00",
    openingHoursSat: "08:00-18:00",
    openingHoursSun: "08:00-18:00",
    closingHoursMon: "08:00-18:00",
    closingHoursTue: "08:00-18:00",
    closingHoursWed: "08:00-18:00",
    closingHoursThu: "08:00-18:00",
    closingHoursFri: "08:00-18:00",
    closingHoursSat: "08:00-18:00",
    closingHoursSun: "08:00-18:00",
    breakingStartHourMon: "08:00-18:00",
    breakingEndHourMon: "08:00-18:00",
    breakingStartHourTue: "08:00-18:00",
    breakingEndHourTue: "08:00-18:00",
    breakingStartHourWed: "08:00-18:00",
    breakingEndHourWed: "08:00-18:00",
    breakingStartHourThu: "08:00-18:00",
    breakingEndHourThu: "08:00-18:00",
    breakingStartHourFri: "08:00-18:00",
    breakingEndHourFri: "08:00-18:00",
    breakingStartHourSat: "08:00-18:00",
    breakingEndHourSat: "08:00-18:00",
    breakingStartHourSun: "08:00-18:00",
    breakingEndHourSun: "08:00-18:00",
  },
  isOpen24Hour: false,
  halalCertified: true,
  muslimOwned: false,
  triFoodPOSes: [
    {
      id: 1,
      POSId: "POS1",
    },
    {
      id: 2,
      POSId: "POS2",
    },
  ],

  merchantStoreApproval: [],
  isAutoThresholdEnabled: false,
  hasOwnDeliveryFleet: false,
  type: "FOOD_DELIVERY",
};

export enum MediaDirectoryEnum {
  STORE = "store",
  MERCHANT = "merchant",
  PRODUCT = "product",
  RATING = "rating",
  CONSUMER = "consumer",
  MISCELLANEOUS = "miscellaneous",
}
